import { on } from 'delegated-events'
import { Swiper } from 'swiper'

const fn = {
  init: () => {
    document.querySelectorAll('.programs-slider').forEach((el) => fn.setupSlider(el))
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper-container')
    const currentIndex = el.querySelector('.programs-slider-current-index')
    const numSlides = container.querySelectorAll('.swiper-slide').length

    const opts = {
      slidesPerView: 'auto',
      centeredSlides: true,
      slideToClickedSlide: true,
      autoHeight: true,
      loop: true,
      loopedSlides: numSlides,
      simulateTouch: false,
      breakpoints: {
        768: {
          autoHeight: false,
          centeredSlides: false,
          slidesOffsetAfter: 1000,
        },
      },
      on: {
        slideChangeTransitionStart: (swiper) => {
          if (currentIndex) {
            currentIndex.textContent = swiper.realIndex + 1
          }
        },
      },
    }

    if (numSlides > 1) {
      const swiper = new Swiper(container, opts)

      swiper.snapGrid = [...swiper.slidesGrid]

      on('click', '.programs-slider-button-prev', () => {
        swiper.slidePrev()
      })

      on('click', '.programs-slider-button-next', () => {
        swiper.slideNext()
      })
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
